import React, {Component} from 'react';
import {
    Row,
    Col,
    Label,
    FormFeedback,
    Input,
    Badge
} from 'reactstrap';

import {Utils, Loading, GestSell, DeleteSell} from "custom";
import {AppointmentAPI, LeadReminderAPI, PaymentAPI} from "api";

import {Grid, _} from 'gridjs-react';

const moment = require("moment")

class ListAppointment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            errors: false,
        };
    }

    checkAppointment(id) {

        const self = this;

        global.SweetAlert.fire({
            title: "Completa Appuntamento",
            text: "Vuoi veramente contrassegnare l'appuntamento come completato?",
            icon: 'info',
            showCancelButton: true,
            confirmButtonText: 'Si, conferma',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ms-1'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve, reject) {
                    AppointmentAPI.edit({
                        id: id,
                        status: "CONFIRMED"
                    }).then(() => {
                        resolve();
                    }).catch(() => {
                        global.SweetAlert.fire({
                            icon: 'error',
                            title: 'Si è verificato un errore :(',
                            text: 'Purtroppo qualcosa è andato storto e non è stato possibile completare l\'appuntamento. Riprova più tardi.',
                            customClass: {
                                confirmButton: 'btn btn-success'
                            }
                        });
                        reject()
                    })
                });
            },
        }).then(function (result) {
            if (result.value) {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Appuntamento completato!',
                    text: 'Appuntamento completato correttamente.',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                });
                self.props.onResolve();
            }
        })
    }


    deleteAppointment(id) {
        const self = this;
        global.SweetAlert.fire({
            title: "Elimina appuntamento",
            text: 'Attenzione, vuoi veramente eliminare l\'appuntamento?',
            icon: 'danger',
            showCancelButton: true,
            confirmButtonText: 'Si, elimina',
            cancelButtonText: 'Annulla',
            customClass: {
                confirmButton: 'btn btn-primary',
                cancelButton: 'btn btn-outline-danger ms-1'
            },
            buttonsStyling: false,
            showLoaderOnConfirm: true,
            preConfirm: function() {
                return new Promise(function(resolve, reject) {
                    AppointmentAPI.edit({
                        id: id,
                        status: "CANCELED"
                    }).then(() => {
                        resolve();
                    }).catch(() => {
                        global.SweetAlert.fire({
                            icon: 'error',
                            title: 'Si è verificato un errore :(',
                            text: 'Purtroppo qualcosa è andato storto e non è stato possibile eliminare l\'appuntamento. Riprova più tardi.',
                            customClass: {
                                confirmButton: 'btn btn-success'
                            }
                        });
                        reject()
                    })
                });
            },
        }).then(function (result) {
            if (result.value) {
                global.SweetAlert.fire({
                    icon: 'success',
                    title: 'Appuntamento eliminato!',
                    text: 'Appuntamento eliminato correttamente.',
                    customClass: {
                        confirmButton: 'btn btn-success'
                    }
                });
                self.props.onResolve();
            }
        })
    }

    render() {

        return <React.Fragment>
            <Grid
                data={this.props.appointments}
                columns={[
                    {
                        id: 'id',
                        hidden: true
                    },
                    {
                        id: 'date_hour',
                        name: "Data e ora",
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            <b>{moment(cell).format("DD/MM/YYYY HH:mm")}</b><br />
                            {moment(cell).fromNow()}
                        </div>)
                    },
                    {
                        id: 'status',
                        name: "Stato",
                        search: false,
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            {cell === "CONFIRMED" ? <Badge color="success" >COMPLETATO</Badge> : null}
                            {cell === "CANCELED" ? <Badge color="danger" >ANNULLATO</Badge> : null}
                            {cell === null ? <Badge color="info" className="cursor-pointer" onClick={() => this.checkAppointment(row.cells[0].data)}>PIANIFICATO</Badge> : null}
                        </div>)
                    },
                    {
                        id: 'id',
                        name: "",
                        search: false,
                        formatter: (cell, row) => _(<div className="text-nowrap text-center">
                            {row.cells[2].data === null ? <li className="list-inline-item cursor-pointer" onClick={() => this.deleteAppointment(row.cells[0].data)}>
                                <i className="ri-delete-bin-2-fill fs-20 text-danger"></i>
                            </li> : null}
                        </div>)
                    }
                ]}
                sort={false}
                pagination={{enabled: true, limit: 10}}
                search={false}
                language={{
                    'search': {
                        'placeholder': '🔍 Cerca...'
                    },
                    'pagination': {
                        'previous': 'Indietro',
                        'next': 'Avanti',
                        'showing': 'Stai visualizzando da',
                        'results': 'Appuntamenti',
                        'to': 'a',
                        'of': 'di',
                    },
                    'noRecordsFound': 'Nessun appuntamento trovato',
                    'error': 'Si è verificato un errore non previsto',
                }}
            />
        </React.Fragment>
    }
}

export default ListAppointment;
